import { FadeIn } from "@/components/Reveal";
import { usePageTitle } from "@/hooks/use-page-title";

const LegalShell = ({ title, updated, children, testid }) => (
  <section data-testid={testid} className="mx-auto max-w-3xl px-5 py-16 sm:px-8 lg:py-24">
    <FadeIn>
      <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-aspira-gold">Aspira Property Group</p>
      <h1 className="mt-4 font-serif text-4xl font-medium tracking-tight text-aspira-ink">{title}</h1>
      <p className="mt-2 text-xs text-aspira-muted">Last updated: {updated}</p>
    </FadeIn>
    <div className="mt-10 space-y-8 text-sm leading-relaxed text-aspira-body">{children}</div>
  </section>
);

const H = ({ children }) => (
  <h2 className="font-serif text-xl font-medium text-aspira-ink">{children}</h2>
);

export const PrivacyPolicy = () => {
  usePageTitle("Privacy Policy | Aspira Property Group");
  return (
    <LegalShell title="Privacy Policy" updated="October 2026" testid="privacy-page">
      <section>
        <H>What we collect</H>
        <p className="mt-3">
          When you submit a form on this site — a cash offer request, a buyers
          list signup, a property inquiry, or a contact message — we collect the
          information you provide, such as your name, email address, phone
          number, and details about your property or the land you're looking for.
        </p>
      </section>
      <section>
        <H>How we use it</H>
        <p className="mt-3">
          We use this information only to respond to your inquiry, review your
          property, discuss potential transactions, and — if you join the buyers
          list — notify you about land that matches what you told us you're
          looking for.
        </p>
      </section>
      <section>
        <H>What we don't do</H>
        <p className="mt-3">
          We do not sell, rent, or share your personal information with third
          parties for their marketing purposes. Information is shared only with
          the service providers needed to operate this website and communicate
          with you, or when required by law.
        </p>
      </section>
      <section>
        <H>Your choices</H>
        <p className="mt-3">
          You can ask us to update or delete your information at any time by
          contacting us at aspirapropertygroup@gmail.com or (612) 913-2888.
        </p>
      </section>
    </LegalShell>
  );
};

export const TermsOfUse = () => {
  usePageTitle("Terms of Use | Aspira Property Group");
  return (
    <LegalShell title="Terms of Use" updated="October 2026" testid="terms-page">
      <section>
        <H>Using this website</H>
        <p className="mt-3">
          This website is provided by Aspira Property Group for general
          information about buying and selling vacant land. By using it, you agree
          to use it lawfully and not to misuse the forms or content.
        </p>
      </section>
      <section>
        <H>No offer or guarantee</H>
        <p className="mt-3">
          Content on this site is not an offer to buy or sell real estate, and
          property information is provided for general reference. Any transaction
          is subject to a separate written agreement, property review, title
          work, and applicable law. Submitting a form does not create an
          obligation on either side.
        </p>
      </section>
      <section>
        <H>Property information</H>
        <p className="mt-3">
          We work to keep listing details accurate, but buyers are responsible for
          their own due diligence, including verifying access, zoning, utilities,
          boundaries, and permitted uses before purchasing.
        </p>
      </section>
      <section>
        <H>Contact</H>
        <p className="mt-3">
          Questions about these terms can be sent to
          aspirapropertygroup@gmail.com or (612) 913-2888.
        </p>
      </section>
    </LegalShell>
  );
};
